const AccountModel = Backbone.Model.extend({

  defaults: {
    id: null,
    file_name: 'Media Item',
  },

  defaultsPropertiesForRssAutoposters: {
    frequency: 'Every hour',
    type: 'Pending',
    quantity: 1,
    showposts: 'no',
    post_content: 'Title with link',
    repeats: "Don't repeat",
    postorder: 'Newest first',
    utm_source: 'rss',
    utm_medium: window.appConfig.title,
    notify: 'Yes',
    state: 'Active',
    service_id: 43,
    shorten_url: 'bit.ly',
    suffix: '',
    prefix: '',
    keyword: '',
    exclude: '',
    display_source: 'Yes',
    ignore_other_repeats: 'No',
    post_to: '',
  },

  initialize() {
    // NOTE: set utm_medium when window.appConfig.title has been set. i.e after
    // the app login process
    this.defaultsPropertiesForRssAutoposters.utm_medium = window.appConfig.title;
  },

  validate() {

    /* Custom validation logic
        *
        * Suggestions:
        *
        *   Validate "id", "link url"?
        *
        */

    // if ( attributes.id === null ) { return "id not set" };
  },

  deleteAccount(accountId, options) {
    Sendible.Connect.deleteAccount(window.appConfig.applicationId, { account_id: accountId }, (data) => {
      options.success(data);
    }, (data) => {
      if (options.error)options.error(data);
    });
  },

  sync(method, model, options) {
    const $username = loginContext.getCurrentDetails().username;

    options.refreshCache = options.refreshCache || false;

    const params = _.omit($.extend(true, {}, options), ['validate', 'parse', 'success', 'reset', 'remove', 'error', 'local', 'updateType', 'refreshCache']);
    // if model doesn't have a collection then create a blank function
    if (model.hasOwnProperty('collection') === false) model.collection = { updateCache() {} };

    if (method !== 'read') {
      model.collection.updateCache();
    }

    if (method == 'read') {
      const cache = new Cache();
      const key = `${$username}_account_${model.attributes.id}`;
      if (cache.read(key) == null || options.refreshCache) {
        return Sendible.Connect.getAccount(
          window.appConfig.applicationId,
          { account_id: model.attributes.id },
          (result) => {
            options.success(result);
            cache.store(key, JSON.stringify(result), 1);
            // model.trigger('sync', model, result, options);
          },
          () => {
            options.error();
          },
        );
      }

      const result = JSON.parse(cache.read(key));
      options.success(result);
      // model.trigger('sync', model, result, options);
    }

    if (method === 'create') {
      params.parameters = JSON.stringify(
        Sendible.Connect.convertIntoParameterFormat(params.parameters),
      );
      Sendible.Connect.createAccount(window.appConfig.applicationId, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }

    if (method === 'update') {
      params.parameters = JSON.stringify(
        Sendible.Connect.convertIntoParameterFormat(params.parameters),
      );
      Sendible.Connect.updateAccount(window.appConfig.applicationId, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }

    if (method === 'delete') {
      Sendible.Connect.deleteAccount(window.appConfig.applicationId, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }
  },

});

export default AccountModel;
